export const trackPageView = (route, meta = {}) => {
  try {
    console.info("[MYV Analytics] page_view", { route, ...meta });
  } catch (error) {
    // Safe no-op: analytics should never block rendering.
  }
};

export const trackEvent = (name, payload = {}) => {
  try {
    console.info("[MYV Analytics] event", { name, ...payload });
  } catch (error) {
    // Safe no-op: analytics should never block rendering.
  }
};
